var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarrerImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1378.72 1369.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#9192ff;}.cls-3{fill:#a8d3f4;}.cls-4{fill:#088cfc;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#fff;}.cls-7{fill:#2b69b3;}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:#fff2e0;opacity:0.7;}.cls-21,.cls-24,.cls-9{isolation:isolate;}.cls-10{fill:url(#linear-gradient-2);}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:#d1d1ff;}.cls-13{fill:#93acbf;}.cls-14{fill:#586773;}.cls-15{fill:#18174a;}.cls-16{fill:url(#linear-gradient-4);}.cls-17{fill:url(#linear-gradient-5);}.cls-18{fill:#ffbc96;}.cls-19{fill:#d28572;}.cls-20{fill:#88c4f2;}.cls-21,.cls-22{fill:#1b1b43;}.cls-21{opacity:0.3;}.cls-23{fill:#ffa121;}.cls-24{fill:#fe5b52;opacity:0.2;}.cls-25{fill:#c5c5ff;}.cls-26{fill:#bdbdef;}.cls-27{fill:#f9e181;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M650.47,761.83a47.27,47.27,0,0,0,47.25,47.25h524.8a47.27,47.27,0,0,0,47.25-47.25V442.49H650.47Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 500.49,
    y1: 734.26,
    x2: 1166.68,
    y2: 734.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 977.84,
    y1: 513.76,
    x2: 1127.07,
    y2: 513.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1026.73,
    y1: 497.01,
    x2: 1113.95,
    y2: 497.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1061.98,
    y1: 307.62,
    x2: 1196.84,
    y2: 307.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1219.09,
    y1: 406.93,
    x2: 1290.58,
    y2: 406.93,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.89,808.29l-1.41-1.48,8.83-8.45,1.42,1.47Zm17.71-17-1.44-1.45c2.88-2.84,5.76-5.76,8.59-8.7l1.47,1.42c-2.83,2.94-5.73,5.88-8.62,8.73Zm17-17.69-1.51-1.37c2.7-3,5.43-6.06,8.11-9.15l1.54,1.33C364.06,767.55,361.33,770.63,358.61,773.64Zm16.05-18.58-1.58-1.29c2.55-3.11,5.12-6.32,7.64-9.55l1.63,1.26c-2.56,3.22-5.14,6.45-7.69,9.56Zm15.11-19.34-1.64-1.23c2.4-3.21,4.81-6.53,7.19-9.89l1.63,1.19c-2.35,3.34-4.77,6.68-7.18,9.91ZM404,715.65l-1.69-1.14q3.44-5.07,6.76-10.19l1.71,1.11Q407.42,710.61,404,715.65ZM515.89,701.5a29.83,29.83,0,0,1-11-2.1l.75-1.9a27.91,27.91,0,0,0,10.25,2,11.79,11.79,0,0,1,1.33,0l.09,2c-.52,0-1.08,0-1.47,0ZM529.45,698l-1-1.77A22.25,22.25,0,0,0,536.6,688l1.77,1a24.24,24.24,0,0,1-9,9Zm-112.08-3L415.64,694q3.21-5.19,6.35-10.45l1.75,1.05q-3.18,5.29-6.42,10.51Zm77.17-2.84a35.88,35.88,0,0,1-6.72-10.62l1.88-.81a33.92,33.92,0,0,0,6.34,10Zm47.19-15.35-2.05,0v-.54a21.1,21.1,0,0,0-1.8-8.68c-.3-.67-.65-1.34-1-2l1.78-1c.39.7.76,1.42,1.09,2.15a23.45,23.45,0,0,1,2,9.52Zm-111-2.14-1.56-1.32a78.14,78.14,0,0,1,8.65-8.8l1.34,1.54a75.68,75.68,0,0,0-8.47,8.61Zm53.91-5.19a50.8,50.8,0,0,1-.35-5.91,52.92,52.92,0,0,1,.41-6.54l2,.26a51,51,0,0,0-.4,6.3,46.64,46.64,0,0,0,.34,5.67ZM448.92,659l-1.07-1.74a84.81,84.81,0,0,1,11-5.71l.82,1.88A82.14,82.14,0,0,0,448.92,659Zm80-2.1a44.78,44.78,0,0,0-10.42-5.77l.76-1.89a47,47,0,0,1,10.91,6.07ZM471,649.44l-.53-2a89.69,89.69,0,0,1,12.15-2.4l.25,2A85.46,85.46,0,0,0,471,649.44ZM507,647.75a73.36,73.36,0,0,0-12-1.26l.05-2a76.3,76.3,0,0,1,12.34,1.29Zm-17.46-2.07-1.92-.68a62.28,62.28,0,0,1,5.4-11.22l1.73,1.07a59.85,59.85,0,0,0-5.19,10.83ZM502,625.26l-1.5-1.38q.9-1,1.83-1.89a66.47,66.47,0,0,1,7.47-6.35l1.21,1.63a63.49,63.49,0,0,0-7.24,6.16c-.59.61-1.18,1.22-1.75,1.83ZM521.32,611l-.91-1.83a74.64,74.64,0,0,1,11.52-4.57l.6,2a73,73,0,0,0-11.2,4.45Zm23-7.5-.51-2c4-1,8-2.1,11.8-3.19l.56,2c-3.84,1.09-7.83,2.16-11.84,3.19ZM568,596.82l-.62-2c3.94-1.24,7.84-2.54,11.6-3.84l.67,1.93c-3.76,1.31-7.68,2.63-11.64,3.86Zm23.18-8.11-.73-1.9c3.82-1.49,7.62-3,11.29-4.63l.82,1.87c-3.69,1.6-7.51,3.16-11.36,4.66ZM613.71,579l-.88-1.83,11-5.35.89,1.84Zm22-10.7-.89-1.84,11-5.36.89,1.84Zm22-10.72-.89-1.84,11-5.35.89,1.83Zm22.06-10.71L679,545l11-5.36.89,1.84Zm22-10.71-.89-1.84,11-5.36.89,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M664.23,156.43c0,.42,0,.84,0,1.25H932.8c-.71-22.13-20-39.88-43.6-39.88a45.56,45.56,0,0,0-20.89,5c.33-17.23-7.95-33.72-23.2-42.58C822.24,67,792.28,76,778.27,100.35a53.54,53.54,0,0,0-7,23.1c-11.17-5.1-25-8.16-40-8.16C694.22,115.3,664.23,133.73,664.23,156.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.51,783.88H-3.9v-.82c.59-18.73,16.61-33.41,36.47-33.41a38.47,38.47,0,0,1,16.34,3.64c.14-14.35,7.49-27.4,19.39-34.31a38.51,38.51,0,0,1,29.5-3.73,43.16,43.16,0,0,1,26.29,20.49,44.43,44.43,0,0,1,5.79,18.17,80.54,80.54,0,0,1,32.09-6.3c30.68,0,55.63,15.46,55.63,34.46a10.29,10.29,0,0,1,0,1.11ZM-2.31,782.35H216.11v-.25c0-18.16-24.27-32.93-54.1-32.93a78.39,78.39,0,0,0-32.45,6.62l-1,.45-.08-1.1a42.86,42.86,0,0,0-5.67-18.6,41.67,41.67,0,0,0-25.36-19.78,37,37,0,0,0-28.34,3.58c-11.76,6.83-18.89,19.93-18.63,34.2v1.28l-1.14-.58a36.84,36.84,0,0,0-16.76-4c-18.73,0-33.9,13.62-34.88,31.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M650.47,761.83a47.27,47.27,0,0,0,47.25,47.25h524.8a47.27,47.27,0,0,0,47.25-47.25V442.49H650.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M618.06,523.94c7.27-23.21,30.14-41.05,55.17-42.91s50.56,12.25,61.51,34.12c13.32-.13,26.44,7.26,32.91,18.51a35.6,35.6,0,0,1-1.15,36.75c15.86,2.76,30.09,13.19,37.11,27.21a48.73,48.73,0,0,1-1,44.92,59.7,59.7,0,0,1,56.52,2c16.74,10.11,27.29,29.15,26.71,48.19,10.87-17.06,31.71-27.68,52.43-26.73s40.47,13.41,49.69,31.38c9.73-29.11,35.66-52.6,66.35-60.11s65.12,1.22,88.08,22.32c34.55,5.41,59.72,42.91,50.72,75.56,18.66,15.44,28.2,40.55,24.3,64s-21.11,44.31-43.83,53.25L579.26,852,528.63,625.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M587.05,591.75c7-23.21,29.15-41,53.34-43s48.84,12.26,59.4,34.07a35.94,35.94,0,0,1,30.64,55.24,49.42,49.42,0,0,1,34.83,72.12,54.83,54.83,0,0,1,80.36,50.18A56.43,56.43,0,0,1,944.24,765c9.42-29.11,34.5-52.63,64.15-60.16s62.89,1.16,85.09,22.25c33.37,5.37,57.66,42.86,49,75.52a69.55,69.55,0,0,1-19,117.22l-574.2.09L500.49,693.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1065.14,452.74c-172,161.76-294,205.38-447.66,221l-10.2,163.35,161.3,55.13c140.88-4.09,276.16-208,359.72-383l-63.16-56.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1097.73,447.85c-28,33.09-70.14,64.73-119.89,107.48l67.88-27.66c-8.33,13.79-20.42,33.09-27.24,41.37,15.64-7.22,40.84-23.11,49.15-31.53,0,11.75-14.16,31.41-20.34,42.15,36.21-31,69.15-68.81,79.78-102l-29.34-29.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1097.29,456.52c-16.54,20.48-41.3,40.22-70.56,66.81l39.61-17.55c-5,8.51-12.19,20.41-16.21,25.53,9.14-4.58,23.89-14.49,28.8-19.73-.12,7.18-8.52,19.33-12.25,25.93,21.29-19.27,40.77-42.71,47.27-63.1l-16.69-17.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.44,568.89c.22,5.13,0,13.76-5.11,16.71-8.53,4.91-15.23-7.05-18.37-13.06-3.73-7.2-2.78-16.13,5.67-19.33C833.79,549,840,559.36,840.44,568.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1244.82,724.16c.22,5.11,0,13.75-5.11,16.71-8.53,4.9-15.24-7-18.37-13.07-3.74-7.19-2.78-16.12,5.67-19.33C1238.16,704.22,1244.41,714.62,1244.82,724.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 795.12,
    cy: 511.05,
    r: 7.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1158.57,
    cy: 639.96,
    r: 10.88,
    transform: "translate(-163.75 582.57) rotate(-26.43)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1222.52,810.1H697.73a48.33,48.33,0,0,1-48.28-48.27V441.5h621.34V761.83A48.33,48.33,0,0,1,1222.52,810.1Zm-571-366.56V761.83a46.28,46.28,0,0,0,46.23,46.23h524.82a46.28,46.28,0,0,0,46.23-46.23V443.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1222.52,318.81H697.72a47.26,47.26,0,0,0-47.25,47.25v76.5h619.3V366.09a47.25,47.25,0,0,0-47.2-47.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1270.79,443.54H649.45V366.09a48.32,48.32,0,0,1,48.28-48.26h524.79a48.31,48.31,0,0,1,48.27,48.26Zm-619.32-2h617.28V366.09a46.27,46.27,0,0,0-46.23-46.22H697.73a46.28,46.28,0,0,0-46.26,46.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 712.82,
    cy: 380.63,
    r: 25.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 785.87,
    cy: 384.12,
    r: 25.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M789.16,407.59a26.95,26.95,0,1,1,27-26.95h0A27,27,0,0,1,789.16,407.59Zm0-51.8A24.89,24.89,0,1,0,814,380.68h0A24.92,24.92,0,0,0,789.16,355.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 858.48,
    y: 355.94,
    width: 152.59,
    height: 49.45,
    rx: 24.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M986.33,406.42H883.21a25.75,25.75,0,0,1,0-51.46H986.33a25.75,25.75,0,0,1,0,51.46ZM883.18,357a23.69,23.69,0,0,0,0,47.37H986.33a23.69,23.69,0,0,0,0-47.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1196.84,262.46c-41.36,36.21-112.71,11.25-134.86,40.16l63.34,50.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1062,302.62h0a24.49,24.49,0,0,0,4.47,24.71l44.92,51.46,14-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1290.58,336.69c-25.76,48.56,14.87,112.27-8.17,140.48L1219.09,427Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1282.4,477.17h0a24.54,24.54,0,0,1-25.09,1.31L1197,446.57,1219,427Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1328.51 200.23 1270.79 220.93 1321.12 259.86 1328.51 200.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1315.53,259.86c-7.88,89.24-73.81,172.49-153.89,218.75l-73-57.73c30.62-96.37,87.64-165.27,177.68-199.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1088.68 420.88 1057.02 442.79 1147.56 514.48 1161.64 478.61 1088.68 420.88"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1245.19,
    cy: 298.18,
    r: 33.87,
    transform: "translate(-25.56 141.32) rotate(-6.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1247.75,322.18l-.21-2a22.37,22.37,0,0,0,5.71-1.38l.74,1.91A24.82,24.82,0,0,1,1247.75,322.18Zm-6.37-.16a24.18,24.18,0,0,1-6.11-1.83l.82-1.87a21.42,21.42,0,0,0,5.58,1.64Zm18.16-4.42-1.21-1.64a22.18,22.18,0,0,0,4.19-4.08l1.63,1.27a24,24,0,0,1-4.61,4.45Zm-29.68-.82a23.18,23.18,0,0,1-4.35-4.66l1.63-1.18a22.1,22.1,0,0,0,4,4.26Zm36.75-7.49-1.81-1a22.35,22.35,0,0,0,2-5.48l2,.44a24,24,0,0,1-2.17,6Zm-44.1-2.81a23.75,23.75,0,0,1-1.39-6.22l2-.18a22.12,22.12,0,0,0,1.27,5.72Zm44.77-9.41a22.23,22.23,0,0,0-1.06-5.71l1.94-.63a24.2,24.2,0,0,1,1.16,6.26Zm-43.83-2.79-2-.36a24.11,24.11,0,0,1,2-6.08l1.84.88a22,22,0,0,0-1.79,5.56Zm40.23-8.22a21.77,21.77,0,0,0-3.82-4.42l1.36-1.52a23.7,23.7,0,0,1,4.17,4.82Zm-35.29-2.25-1.55-1.32a24.12,24.12,0,0,1,4.75-4.27l1.15,1.69a22.17,22.17,0,0,0-4.35,3.91Zm26.64-5.43a22.11,22.11,0,0,0-5.52-1.89l.39-2a23.89,23.89,0,0,1,6,2.06ZM1238,277.29l-.66-1.93a23.71,23.71,0,0,1,6.24-1.27l.14,2a22.39,22.39,0,0,0-5.72,1.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1056.12,
    y: 458.96,
    width: 113.3,
    height: 13.04,
    rx: 5.5,
    transform: "translate(57.08 1048.97) rotate(-51.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1190.81,1209.77h-12.25v-2h12.25Zm-24.5,0h-12.25v-2h12.25Zm-24.51,0h-12.25v-2h12.25Zm-24.5,0h-12.25v-2h12.25Zm-24.5,0h-12.25v-2h12.25Zm-24.5,0h-12.25v-2h12.25Zm-24.5,0h-12.25v-2h12.25Zm-24.5,0h-12.25v-2h12.25Zm-24.51,0H982.54v-2h12.25Zm-24.5,0H958v-2h12.25Zm-24.5,0a39.24,39.24,0,0,1-12.34-2.11l.66-1.93a37.29,37.29,0,0,0,11.7,2Zm246.5,0-.08-2a37.09,37.09,0,0,0,11.64-2.33l.72,1.91a39.46,39.46,0,0,1-12.29,2.46Zm-269.88-8a39.13,39.13,0,0,1-8.62-9.08l1.68-1.15a37.58,37.58,0,0,0,8.17,8.62Zm293-.68-1.28-1.59a37.08,37.08,0,0,0,7.92-8.84l1.73,1.11a39.2,39.2,0,0,1-8.38,9.28Zm-307-19.73a39.31,39.31,0,0,1-1.49-10.73V1169h2v1.63a37.08,37.08,0,0,0,1.41,10.16Zm320.3-1.08-2-.5a37.12,37.12,0,0,0,1.14-9.15v-2.75h2v2.69a38.94,38.94,0,0,1-1.21,9.67ZM909,1156.68h-2v-12.25h2Zm321-1.08h-2v-12.25h2Zm-321-23.42h-2v-12.25h2Zm321-1.08h-2v-12.25h2Zm-321-23.42h-2v-12.25h2Zm321-1.08h-2v-12.25h2Zm-321-23.42h-2v-12.25h2Zm321-1.08h-2v-12.25h2Zm-321-23.42h-2v-12.26h2Zm321-1.08h-2v-12.25h2Zm-321-23.43h-2V1026a39.07,39.07,0,0,1,.22-4.19l2,.22a37.57,37.57,0,0,0-.21,4Zm321-1.07h-2V1026a38.51,38.51,0,0,0-.33-5l2-.27a39.21,39.21,0,0,1,.35,5.3ZM912.4,1010.59l-1.87-.81a39.28,39.28,0,0,1,7-10.42l1.49,1.4a36.78,36.78,0,0,0-6.62,9.83Zm311.76-.94a37.07,37.07,0,0,0-6.88-9.68l1.46-1.43a39,39,0,0,1,7.25,10.2ZM928.34,993.43l-1-1.79a38.7,38.7,0,0,1,11.81-4.17l.36,2A37.08,37.08,0,0,0,928.34,993.43Zm279.32-.49a37.19,37.19,0,0,0-11.3-3.64l.3-2a38.83,38.83,0,0,1,11.93,3.83Zm-23.38-4.09H1172v-2h12.25Zm-24.5,0h-12.25v-2h12.25Zm-24.5,0H1123v-2h12.25Zm-24.5,0h-12.25v-2h12.25Zm-24.5,0H1074v-2h12.26Zm-24.51,0h-12.25v-2h12.25Zm-24.5,0H1025v-2h12.25Zm-24.5,0h-12.25v-2h12.25Zm-24.5,0H976v-2h12.25Zm-24.5,0H951.52v-2h12.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 877.66,
    y: 947.41,
    width: 320.95,
    height: 226.96,
    rx: 30.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 933.47,
    y: 1079.98,
    width: 34.75,
    height: 70.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 991.66,
    y: 1082.25,
    width: 34.75,
    height: 68.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1049.86,
    y: 1046.56,
    width: 34.75,
    height: 103.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1108.06,
    y: 1016.06,
    width: 34.75,
    height: 134.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 944.9,
    y: 979.38,
    width: 186.47,
    height: 8.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M377.16,725.85a96.73,96.73,0,0,0-35.59-51.08l-6.89-5.08,5.85,121.1,45.25-35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M522.56,872.19,512.5,852.51A19.92,19.92,0,0,0,500,842.34l-29.57-8.17L394.38,785.6l-8.6-29.82-45.25,35,.41,8.5a44.75,44.75,0,0,0,26.95,38.93l73.88,31.85,35.12.82c11.32,3.89,15.23,13.65,22.25,10.14,2.62-1.31-7.61-18.15-7.61-18.15l17,18.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 381.71,
    y: 790.34,
    width: 15.36,
    height: 2.34,
    transform: "translate(-465.98 575.95) rotate(-49.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M390.22,921.23l55.36-4.9c36-3.18,67.38,25.91,69.14,64.18l12.5,272.63-76.35,2.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "457.01 1252.82 459.34 1328.13 572.5 1328.13 516.7 1281.7 513.19 1245.41 457.01 1252.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 489.77,
    y: 1288.57,
    width: 30.05,
    height: 4.68,
    transform: "translate(-682.91 576.34) rotate(-37.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "431.25 1252.82 433.59 1328.13 546.75 1328.13 490.95 1281.7 487.44 1245.41 431.25 1252.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 464.01,
    y: 1288.56,
    width: 30.05,
    height: 4.68,
    transform: "translate(-688.26 560.62) rotate(-37.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M515.53,1260.23H421.89l-66.74-205.36-9.35-28.75-133.44-.59c-8.24-.11-16.13-3.93-22.87-9.57-14.17-12-20.7-30.79-18.11-49.14l11.71-83.51,198.25,25.77A89,89,0,0,1,457,979.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "373.31 1026.12 355.14 1054.87 345.8 1026.12 373.31 1026.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M348.8,868.19c-1,3.86-2,7.73-3,11.61l-7,28.68-92.48-3.84-66.58-2.78a28.59,28.59,0,0,1-26.83-34.41l31-149.39a56.7,56.7,0,0,1,50.19-47.58l76-7.82,24.57,7c24,12.87,24,36.21,25.17,51.5C364.88,788.09,358.67,828.62,348.8,868.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M286.1,863.41c-1,3.87,60.73,12.51,59.7,16.39l-7,28.68-92.48-3.84c-32.3-24.37-44.4-77.4-56.18-143.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M267.72,705.85a55.69,55.69,0,0,0,13.82,10.95,45.69,45.69,0,0,0,16.52,5.58c5.71.74,11.77.26,16.8-2.45,5.14-2.56,8.41-7.95,9-13.79l.91.05a18.75,18.75,0,0,1-2.32,8.91,17.72,17.72,0,0,1-6.61,6.62c-5.5,3.18-12,3.76-18.1,3a44.93,44.93,0,0,1-17.21-6.16A48.8,48.8,0,0,1,267,706.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M361.89,797.14l-1.75-.12c1.69-23.55,0-52.51-5.06-86l1.73-.26C361.87,744.38,363.58,773.46,361.89,797.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 432.03,
    y: 880.19,
    width: 87.01,
    height: 17.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "669.66 897.36 494.85 897.36 575.24 743.62 750.04 743.62 669.66 897.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287,539.75C266.5,519.56,227.87,528,228.45,562c-42.14,11.12-44.48,57.36-27.51,81.06l14.64,1.17L218.79,627l8.49,17.55,41,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M321.22,615.25v64.52a12.24,12.24,0,0,1-.08,1.72,21.64,21.64,0,0,1-23.29,19.87,20.72,20.72,0,0,1-3.66-.61,43.54,43.54,0,0,1-32.67-42.51l.33-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M321.22,643.13v36.59a12.1,12.1,0,0,1-.08,1.71c-17.24-2.8-37.2-22.77-42.1-44.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M356.13,620a116.63,116.63,0,0,1-3.68,15.35c-5.15,16.34-14.4,30-30.95,27.58-38.91-5.57-60.56-45.65-60.56-45.65l26.61-30.43,17.86-24L359,586A202.22,202.22,0,0,1,356.13,620Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M272.44,607c17.08-.55,30.29-9.25,35.94-33.95,0,0,39.8,34.3,59.3,16,16.34-15.36-11.38-50.69-57.25-54.9a65,65,0,0,0-46.5,14.21c-22.24,17.82-24.36,59.25-3.58,73.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M252.45,563.74c-1.12-4-.29-8.51,1.52-12.36a27.36,27.36,0,0,1,8-9.85,28.1,28.1,0,0,1,11.44-5.37,20.74,20.74,0,0,1,12.36,1,69.13,69.13,0,0,0-10.62,4.28,57.29,57.29,0,0,0-9,5.71,52.49,52.49,0,0,0-7.66,7.24A42.8,42.8,0,0,0,252.45,563.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 267.37,
    cy: 609.75,
    rx: 13.31,
    ry: 16.09,
    transform: "matrix(0.93, -0.37, 0.37, 0.93, -207.48, 143.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M267.32,618.63a19.11,19.11,0,0,0-.51-8,22.77,22.77,0,0,0-4.21-6.9l.57-.71a11.71,11.71,0,0,1,5.13,15.73,1,1,0,0,1-.1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M331.31,610a4,4,0,1,1-3.95-4.38A4.18,4.18,0,0,1,331.31,610Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352,613.45a3.53,3.53,0,1,1-3-4.3A3.72,3.72,0,0,1,352,613.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M331.08,599c.15,2-3.12,2.23-7.94,2.38S315,603,315,601.73s3.53-4.61,8.28-5.41S330.88,596.58,331.08,599Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M346.47,601c-.36,2,2,2.54,5.61,3.16s5.87,2.45,6.05,1.16-2.09-4.9-5.52-6.21S346.9,598.58,346.47,601Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M340.74,617.08a33.23,33.23,0,0,0,3,3.08l1.58,1.47a8.75,8.75,0,0,1,1.63,1.86,3.23,3.23,0,0,1,.5,1.56,3,3,0,0,1-.39,1.64,5.91,5.91,0,0,1-1.88,1.91,11.94,11.94,0,0,1-4.39,1.58l-.33-.82a34.09,34.09,0,0,0,3.49-2.38,4.4,4.4,0,0,0,1.08-1.31c.19-.39.13-.52-.08-1-.52-.81-1.85-2-2.72-3.17a13.24,13.24,0,0,1-2.29-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.92,631.53a29.55,29.55,0,0,0,7.88,6.86,16.5,16.5,0,0,0,9.95,1.72l.25.88a12.14,12.14,0,0,1-5.66,1.07,12.86,12.86,0,0,1-5.64-1.63,18.18,18.18,0,0,1-7.55-8.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 306.88,
    cy: 619.34,
    r: 9.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M356.13,620a116.63,116.63,0,0,1-3.68,15.35,9.64,9.64,0,0,1,.86-13.62A9.4,9.4,0,0,1,356.13,620Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "245.92 734.26 190.12 760.79 207.61 802.27 266.12 775.3 245.92 734.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M452.6,878.13c-1.55-.82-2.52-1.3-2.52-1.3l.56-1.1s1,.5,2.53,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M475.73,883.9c-1.8,3.56-15.61-2.74-22.05-5.9,5,2.76,13.58,8.17,9.76,11.16-3.06,2.37-9.86-2.67-32.09-11.89,3.37,1.6,23.25,11.05,18.23,14.63-5.45,3.89-28.86-4.68-28.86-4.68l-20.3,10.91H377.05l-84.24.54a60.9,60.9,0,0,1-15.61-2,70,70,0,0,1-27.39-14.18,68.64,68.64,0,0,1-13-14.59,77.52,77.52,0,0,1-7-13l-22.22-52.62,58.47-27,30.52,62L397.3,859.11l28.1-7c6-1.52,14.59,1,19.9,4.28C458.27,864.3,477.42,880.5,475.73,883.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M278.68,888a25.35,25.35,0,0,1-1.52,8.71,70,70,0,0,1-27.39-14.19,68.64,68.64,0,0,1-13-14.59A25.76,25.76,0,0,1,278.68,888Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M397.17,858.68a194.89,194.89,0,0,1,21.23-5.83,76.73,76.73,0,0,1,11-1.56,33.35,33.35,0,0,1,5.65.15c.94.19,1.88.43,2.81.65a20.15,20.15,0,0,1,2.65,1c6.85,3.1,12.82,7.54,18.59,12.11a214.29,214.29,0,0,1,16.51,14.7l.24.24.05.3a4.41,4.41,0,0,1-.56,3.17,3.7,3.7,0,0,1-1.27,1.12,3.59,3.59,0,0,1-1.46.51,12.13,12.13,0,0,1-5.25-.51,52.23,52.23,0,0,1-9.09-3.83c-2.87-1.52-5.72-3.12-8.43-4.84s-5.43-3.5-8.17-5.24l1.24-2a147.83,147.83,0,0,1,13.89,9.21,38.18,38.18,0,0,1,6.28,5.77,8.2,8.2,0,0,1,1.21,2.06,3.68,3.68,0,0,1,.28,1.43A2.69,2.69,0,0,1,464,889a4.37,4.37,0,0,1-2.38,1.33,14.29,14.29,0,0,1-2.26.31h-.22l-.26-.1-25.41-10.62.76-1.79a89,89,0,0,1,11.62,6.27c1.81,1.29,3.71,2.45,5.05,4.71a2.75,2.75,0,0,1,.21,2.24,3,3,0,0,1-1.51,1.55,8.31,8.31,0,0,1-3.5.81c-4.55.11-8.83-1-13.07-2a127.49,127.49,0,0,1-12.5-3.93l.31-.87c4.08,1.38,8.28,2.59,12.49,3.59A44.39,44.39,0,0,0,446,892.09c2-.08,4.37-1,3.4-2.27-.92-1.54-2.8-2.84-4.53-4a86.73,86.73,0,0,0-11.43-6l.77-1.79,25.5,10.42-.48-.08a10.21,10.21,0,0,0,1.83-.26,2.39,2.39,0,0,0,1.2-.57c.35-.15-.12-1.4-.92-2.34a35.52,35.52,0,0,0-5.87-5.43,145.36,145.36,0,0,0-13.7-9l1.23-2c2.7,1.73,5.31,3.59,8.05,5.22s5.47,3.27,8.26,4.8a50.2,50.2,0,0,0,8.64,3.68,10.12,10.12,0,0,0,4.23.49l.45-.07.35-.18c.27-.08.35-.3.53-.43a2.31,2.31,0,0,0,.26-1.48l.29.54c-5.18-5.11-10.62-10-16.25-14.64s-11.52-9-18-12.07l-2.45-1c-.82-.21-1.68-.44-2.53-.62a31.65,31.65,0,0,0-5.33-.21,76.78,76.78,0,0,0-10.79,1.31,186.87,186.87,0,0,0-21.24,5.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "207.97 803.08 207.24 801.49 264.96 774.85 240.92 718.58 242.53 717.89 267.25 775.74 207.97 803.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 213.17,
    y: 1049.54,
    width: 3.06,
    height: 263.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M141,1025H288.44a18.15,18.15,0,0,1,18.15,18.15h0a18.14,18.14,0,0,1-18.15,18.14H141a18.15,18.15,0,0,1-18.15-18.14h0A18.16,18.16,0,0,1,141,1025Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M179.94,1300.19h69.52a27.28,27.28,0,0,1,27.28,27.28h0v3H152.65v-3a27.28,27.28,0,0,1,27.28-27.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 519.46,
    y: 883.79,
    width: 3.07,
    height: 490.78,
    transform: "matrix(0.85, -0.53, 0.53, 0.85, -518.55, 446.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 277.58,
    y: 1119.9,
    width: 489.95,
    height: 3.06,
    transform: "translate(-704.69 964.75) rotate(-57.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 293.52,
    y: 897.36,
    width: 458.08,
    height: 34.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M331.92,346.58a95.74,95.74,0,1,1,95.77-95.73A95.74,95.74,0,0,1,331.92,346.58Zm0-189.42a93.7,93.7,0,1,0,93.68,93.7h0A93.79,93.79,0,0,0,331.92,157.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 396.65,
    cy: 213.34,
    r: 104.16
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "396.68 215.31 338.94 170.05 340.84 167.63 396.62 211.37 427.72 185.03 429.7 187.36 396.68 215.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.36,438H73.47a15.41,15.41,0,0,0-15.42,15.41v52.89a15.41,15.41,0,0,0,15.42,15.41h37.74l16.27,22.46V521.62a15.4,15.4,0,0,0,14.29-15.35V453.38A15.41,15.41,0,0,0,126.36,438Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.5,547.29,110.68,522.7H73.47A16.45,16.45,0,0,1,57,506.27V453.38a16.46,16.46,0,0,1,16.44-16.44h52.89a16.46,16.46,0,0,1,16.43,16.44v52.89a16.49,16.49,0,0,1-14.29,16.28ZM73.47,439a14.4,14.4,0,0,0-14.4,14.39v52.89a14.41,14.41,0,0,0,14.4,14.39h38.26L126.43,541V520.68l.95-.08a14.42,14.42,0,0,0,13.34-14.33V453.38A14.4,14.4,0,0,0,126.33,439Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "98.83 507.04 77.66 476.46 82.69 472.98 98.27 495.48 121.73 453.48 127.08 456.47 98.83 507.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 37.29,
    y: 1327.41,
    width: 1254.85,
    height: 3.06
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrerImg);
export default __webpack_public_path__ + "static/media/carrer_img.401ffecaf56e3feae4e9c906c3dc6f4f.svg";
export { ForwardRef as ReactComponent };